var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NamedRoutes } from "../NamedRoutes";
import { UserType } from "healthex-common/user.dtos";
export class GlobalAdminNewOrganizationViewModel {
    constructor(container) {
        this.routingUIManager = container.routingUIManager;
        this.adminUIManager = container.globalAdminUIManager;
    }
    get organizationType() {
        return this.adminUIManager.organizationTypeToAdmin;
    }
    onCreate(organizationId) {
        if (this.organizationType === UserType.HEALTHCARE_ORGANIZATION) {
            this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL, { orgId: organizationId });
        }
        else if (this.organizationType === UserType.EXTERNAL_RESEARCHER) {
            this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL, { orgId: organizationId });
        }
        else if (this.organizationType === UserType.SERVICE_PROVIDER) {
            this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL, { orgId: organizationId });
        }
    }
    onCancel() {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN);
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminNewOrganizationViewModel.prototype, "organizationType", null);
